<template>
    <v-dialog persistent v-model="dialog" max-width="300">
        <v-card>
            <v-card-title class="bg-yellow-darken-4 d-flex justify-space-between pa-2">
                <span class="title text-white pl-2">
                    <v-icon size="small">mdi-help</v-icon>
                    Confirm
                </span>
                <v-icon class="pt-2" size="small" @click="closeDialog">mdi-close</v-icon>
            </v-card-title>
            <v-divider></v-divider>
            <perfect-scrollbar>
                <v-card-text>
                    <div class="d-flex flex-column justify-center align-center">
                        <sm-lottie width="100" height="100" filename="question.json" />
                        <p class="text-subtitle-2 font-weight-regular text-red text-center">{{ title }}</p>
                    </div>
                </v-card-text>
            </perfect-scrollbar>
            <v-divider></v-divider>
            <v-card-actions class="pa-2">
                <v-btn size="small" prepend-icon="mdi-close" color="error" variant="tonal" @click="closeDialog">NO</v-btn>
                <v-spacer></v-spacer>
                <v-btn size="small" prepend-icon="mdi-check" @click="sm-confirm-dialog" color="secondary" variant="flat">YES</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            message: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                dialog: false,
                resolve: null,
                title: null,
            };
        },
        mounted() {
            this.title = this.message
        },
        methods: {
            closeDialog() {
                this.dialog = false;
                if (this.resolve) {
                    this.resolve(false); // Resolve with false
                    this.resolve = null; // Clear resolve function
                }
            },
            showDialog(title) {
                this.title = title
                return new Promise((resolve) => {
                    this.dialog = true;
                    this.resolve = resolve; // Store the resolve function
                });
            },
            ConfirmDialog() {
                this.dialog = false;
                if (this.resolve) {
                    this.resolve(true); // Resolve with true
                    this.resolve = null; // Clear resolve function
                }
            },
        },
    };
</script>
